import { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames'
import Navbar from 'components/navbar'
import { filter, includes, map } from 'lodash'
import useWindowSize from 'lib/hooks/useWindowSize'
import ReappearingHeader from 'components/reappearing-header'
import useCurrentUser from 'shared/hooks/useCurrentUser/useCurrentUser'
import { STORE_NAVBAR_CATEGORY_SLUGS } from 'shared/constants'
import css from './navbar.scss'
import SearchModal from '../store-search'
import CategorySelect from '../category-select'
import CategoryDropdown from './components/category-dropdown'
import { NAV_COLOR, NAV_HEIGHT } from './constants'
import { useFeature } from 'flagged'

const StoreNavbar = ({
  categoryTree,
  activeSlugSet,
  affix,
  isSignupAccessibilityEnabled,
}) => {
  const { width } = useWindowSize()
  const [currentUser] = useCurrentUser()
  const [microUtilityEnabled, setMicroUtilityEnabled] = useState(false)

  // on mount pick up the currentUser
  useEffect(() => {
    setMicroUtilityEnabled(!currentUser)
  }, [currentUser])

  let navItems = filter(categoryTree, (c) =>
    includes(STORE_NAVBAR_CATEGORY_SLUGS, c.urlSlug)
  )

  const navbarRef = useRef(null)
  const [top, setTop] = useState(0)

  useEffect(() => {
    const getModalBackdropOffset = () => {
      if (navbarRef.current) {
        const { bottom } = navbarRef.current.getBoundingClientRect()
        setTop(bottom + 2)
      }
    }
    getModalBackdropOffset()
    window.addEventListener('scroll', getModalBackdropOffset)

    return () => {
      window.removeEventListener('scroll', getModalBackdropOffset)
    }
  }, [])

  const backdrop = (
    <div
      className={`modal-backdrop ${css.dropdownBackdrop}`}
      style={{ top: top }}
    />
  )

  const c1UnifiedSearchPhase2Enabled = useFeature(
    'c1_unified_search_phase_2_enabled'
  )
  const showGlobalSearchBar = c1UnifiedSearchPhase2Enabled

  const navbar = (
    <div className={css.catalogNavBarContainer} ref={navbarRef}>
      <div className={showGlobalSearchBar && css.searchBarHidden}>
        <SearchModal />
      </div>
      <Navbar className={classNames('hidden-xs', css.catalogNavBar)} secondary>
        {map(navItems, (category) => (
          <CategoryDropdown
            category={category}
            key={category.urlSlug}
            isActiveItem={includes(activeSlugSet, category.urlSlug)}
            backdrop={backdrop}
          />
        ))}
      </Navbar>
      <CategorySelect globalSearchBarEnabled={showGlobalSearchBar} />
    </div>
  )

  return affix ? (
    <ReappearingHeader
      placeholderHeight={NAV_HEIGHT}
      placeholderColor={NAV_COLOR}
      microUtilityBarEnabled={microUtilityEnabled}
    >
      {navbar}
    </ReappearingHeader>
  ) : (
    navbar
  )
}

StoreNavbar.propTypes = {
  affix: PropTypes.bool.isRequired,
  activeSlugSet: PropTypes.array.isRequired,
  categoryTree: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      urlSlug: PropTypes.string.isRequired,
    })
  ).isRequired,
  isSignupAccessibilityEnabled: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    categoryTree: state.categoryTree,
  }
}

export default connect(mapStateToProps)(StoreNavbar)
